import { FaqData } from '../../models/faq-data.model';

export interface State {
  faqData: FaqData | null;
  isLoading: boolean;
  error: string | null;
}

export const initialState: State = {
  faqData: null,
  isLoading: false,
  error: null,
};
